import React, { useRef } from "react";
import "../../styles/components/Admin/AdminSearchBar.scss";
import i18next from "i18next";
import Utility from "../../utility/Utility";
import ErrorBoundaryHandler from "../ErrorBoundaryHandler";

interface AdminSearchBarProps {
  placeholderKey: string;
  onSearch: (search: string) => void;
  onInput: (search: string) => void;
}

const Search = ({ placeholderKey, onSearch, onInput }: AdminSearchBarProps) => {
  const placeholderStr = i18next.t(placeholderKey);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleKeyDown = (e: any) => {
    const search = inputRef?.current?.value;
    if (e.code === "Enter") {
      if (search && search?.length > 2) {
        onSearch(search);
      }
    }
  };

  const handleOnInput = (e: any) => {
    onInput(e.target.value);
  };

  const handleSearchIconClick = () => {
    const search = inputRef?.current?.value;
    if (search && search?.length > 2) {
      onSearch(search);
    }
  };

  return (
    <div className="searchAdminBar">
      <div className="searchImgInput">
        <input
          id="searchInput"
          type={"search"}
          placeholder={placeholderStr}
          onKeyDown={handleKeyDown}
          onInput={handleOnInput}
          onChange={Utility.englishOnlyWithSpecialCharacter}
          ref={inputRef}
        />
        <img
          className="search-icon"
          src="/icons/AdminsearchIcon.svg"
          alt="search icon"
          onClick={handleSearchIconClick}
        />
      </div>
    </div>
  );
};

export default ErrorBoundaryHandler(Search);
